<div class="vendors-container">
  <h2>Vendors</h2>

  <div class="actions-section">
    <button mat-raised-button class="create-btn" (click)="createVendor()">
      <mat-icon>add</mat-icon>
      Create New Vendor
    </button>
  </div>

  <div class="vendors-content">
    <div *ngIf="loading" class="loading-message">
      <p>Loading vendors...</p>
    </div>

    <div *ngIf="error" class="error-message">
      <p>{{ error }}</p>
      <button mat-raised-button color="primary" (click)="loadVendors()">Retry</button>
    </div>

    <div *ngIf="!loading && !error" class="table-container">
      <!-- Search Filter -->
      <mat-form-field class="filter-field">
        <mat-label>Search vendors</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Search by name..." #input>
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>

      <!-- Vendors Table -->
      <table mat-table [dataSource]="dataSource" matSort class="vendors-table">

        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Vendor Name</th>
          <td mat-cell *matCellDef="let vendor">{{ vendor.name || 'Unnamed' }}</td>
        </ng-container>

        <!-- QuickBooks Vendor ID Column -->
        <ng-container matColumnDef="qBO_Vendor_Id">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>QB Vendor ID</th>
          <td mat-cell *matCellDef="let vendor">{{ vendor.qBO_Vendor_Id || '-' }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="table-row clickable-row" (click)="editVendor(row)"></tr>

        <!-- No Data Row -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell no-data" [attr.colspan]="displayedColumns.length">
            <div class="no-vendors">
              <mat-icon>store</mat-icon>
              <p *ngIf="!input.value">No vendors found. Click "Create New Vendor" to add your first vendor.</p>
              <p *ngIf="input.value">No vendors match "{{ input.value }}"</p>
            </div>
          </td>
        </tr>
      </table>

      <!-- Paginator -->
      <mat-paginator
        [pageSizeOptions]="[5, 10, 25, 50]"
        [pageSize]="10"
        showFirstLastButtons
        aria-label="Select page of vendors">
      </mat-paginator>
    </div>
  </div>
</div>
